<template>
  <div>
    <Card>
      <p slot="title">
          Printer
      </p>
      <Input v-model="printerIP" placeholder="IP Printer" style="width: 200px"></Input>
      <Input v-model="printer.printername"  placeholder="Printer name" style="width: 200px"
        @on-change="saveData"></Input>
    </Card>
    <br/>
    <Card>
      <p slot="title">
          Server
      </p>
      <Input 
        v-model="serverIP" placeholder="Server" style="width: 200px" readonly></Input>      
    </Card>
    <br/>
    <!--
    <Card>
      <p slot="title">
          Password Piutang
      </p>
      <Input type="password" v-model="passwordReceivable" placeholder="Password Piutang" style="width: 200px"></Input>
    </Card>
    -->
  </div>
</template>

<script>

import {SPARK} from '@/components/http-lib'
let server = localStorage.getItem('serverUrl')

export default {
  data: () => ({
    printerIP : localStorage.getItem('printerIP'),
    serverIP : server,
    passwordReceivable : '',
    printer : {
      printername : localStorage.getItem('printerName'),
      printerlist : []
    }
  }),
    props: ['title'],

    methods: {
        saveData: function(){
          /*
          if(this.printerIP == '' 
              || this.serverIP ==''
              || this.passwordReceivable =='' ){

          } else {
            settings.set('printer', {
              printerIP: this.printerIP,
              serverIP: this.serverIP
            });

            settings.set('password', {
              passwordReceivable: this.passwordReceivable
            });            
          }

            settings.set('printer', {
              printerIP: this.printerIP,
              serverIP: this.serverIP
            });
            settings.set('password', {
              passwordReceivable: this.passwordReceivable
            });                      
            */
            localStorage.setItem('printerName', this.printer.printername )         
        },
        loadData: function(){
          this.printerIP = settings.get('printer.printerIP', '');
          this.serverIP = settings.get('printer.serverIP', '');
          this.printer.printername = settings.get('printer.printername', '');          
          this.passwordReceivable = settings.get('password.passwordReceivable', '');
          
        },
        getPrinterList : function(){
          console.log('getPrinterList......')
               SPARK
                    //.post('getprinter', { data : 'data'})
                    .get('getprinter')
                    .then(response => {
                        console.log(response.data)
                        let printerlist = []
                        _.forEach(response.data, function(printer) {
                          printerlist.push(printer.name)
                        });                        
                      //  console.log(printerlist) 
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Aplikasi Printer Tidak Terhubung",
                            desc: "Pastikan Aplikasi Printer sudah dijalankan",
                            duration: 0
                        });
                    })          
        }
    },
    watch: {
      printer: function (e) {
        this.saveData();
      },
      printerIP: function (e) {
        this.saveData();
      },      
      serverIP: function (e) {
        this.saveData();
      },
      passwordReceivable: function (e) {
        this.saveData();
      }            
    },
    created() {
      this.loadData();
      // this.getPrinterList();
    }



}


</script>
<style>
</style>



// WEBPACK FOOTER //
// Settings.vue?c796563e